import * as z from "zod";

export const UserFavoriteSchema = z.object({
  id: z.string(),
  pageUrl: z.string(),
  pageName: z.string(),
  workspaceId: z.string(),
});

export const WorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  workspaceUrl: z.string(),
  logo: z.string().nullable().optional(),
});

export const WorkspaceMembershipSchema = z.object({
  userId: z.string(),
  workspaceId: z.string(),
  role: z.string(),
  status: z.string(),
  workspace: WorkspaceSchema.nullable().optional(),
});

export const CurrentUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  fullname: z.string().nullable().optional(),
  username: z.string().nullable().optional(),
  profilePicture: z.string().nullable().optional(),
  superUser: z.boolean(),
  workspaceMembershipList: z.array(WorkspaceMembershipSchema).nullable().optional(),
});

export type UserFavorite = z.infer<typeof UserFavoriteSchema>;
export type Workspace = z.infer<typeof WorkspaceSchema>;
export type WorkspaceMembership = z.infer<typeof WorkspaceMembershipSchema>;
export type CurrentUser = z.infer<typeof CurrentUserSchema>;
